import gql from "graphql-tag";

export const GET_REDIS_KEY = gql`
    query getRedisKey($key: String!) {
        getRedisKey(key: $key)
    }
`;

export const REDIS_KEYS = gql`
    query redisKeys {
        redisKeys
    }
`;

export const SET_REDIS_KEY = gql`
    mutation setRedisKey($key: String!, $data: JSON!) {
        setRedisKey(key: $key, data: $data)
    }
`;

export const DELETE_REDIS_KEY = gql`
    mutation deleteRedisKey($key: String!) {
        deleteRedisKey(key: $key)
    }
`;
